import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const steps = [{
  emoji: '🛒',
  title: 'Realizás tu compra',
  desc: 'De forma 100% segura, con Mercado Pago, tarjeta o transferencia.',
  tint: 'bg-sky-50/70 border-sky-100'
}, {
  emoji: '📧',
  title: 'Recibís un email automático',
  desc: 'En pocos minutos llega a tu casilla con todo listo para acceder.',
  tint: 'bg-amber-50/70 border-amber-100'
}, {
  emoji: '📂',
  title: 'Descargás todo el material',
  desc: 'Todos los tomos y bonos en PDF, en un solo lugar.',
  tint: 'bg-violet-50/60 border-violet-100'
}, {
  emoji: '🖨️',
  title: 'Lo usás como prefieras',
  desc: 'Imprimílos o usalos desde el celular, la tablet o la computadora.',
  tint: 'bg-emerald-50/60 border-emerald-100'
}, {
  emoji: '📚',
  title: 'Empezás el mismo día',
  desc: 'Comenzás la primera sesión de lectura hoy, sin esperar nada.',
  tint: 'bg-rose-50/60 border-rose-100'
}];
export function DeliverySection() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-65">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-66">
        <div className="text-center mb-10" data-id="element-67">
          <span className="text-gold font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-68">
            Simple y al instante
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-navy" data-id="element-69">
            ¿Cómo recibo el material?
          </h2>
        </div>

        <ol className="relative" data-id="element-70">
          {steps.map((step, i) => <li key={i} data-id="element-71">
              <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className={`flex items-center gap-4 rounded-2xl border shadow-sm p-5 ${step.tint}`} data-id="element-72">
                <div className="relative flex-shrink-0" data-id="element-73">
                  <div className="w-12 h-12 rounded-xl bg-white shadow-sm flex items-center justify-center text-2xl" data-id="element-74">
                    <span aria-hidden="true" data-id="element-75">{step.emoji}</span>
                  </div>
                  <span className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-navy text-white text-xs font-bold flex items-center justify-center" data-id="element-76">
                    {i + 1}
                  </span>
                </div>
                <div data-id="element-77">
                  <h3 className="font-bold text-navy text-lg leading-tight" data-id="element-78">
                    Paso {i + 1} · {step.title}
                  </h3>
                  <p className="text-sm text-slate-600 mt-1" data-id="element-79">{step.desc}</p>
                </div>
              </motion.div>

              {i < steps.length - 1 && <div className="flex justify-center py-2" aria-hidden="true" data-id="element-80">
                  <ChevronDown className="w-6 h-6 text-gold" data-id="element-81" />
                </div>}
            </li>)}
        </ol>
      </div>
    </section>;
}